import config from '../nyConfig'
const ApiGoods = {
    "添加商品": new config({ url: '/goods/addGoods', showSuccessMessage: true, useToken: true }),
    "修改商品": new config({ url: '/goods/editGoods', showSuccessMessage: true, useToken: true }),
    "删除商品": new config({ url: '/goods/delGoods', showSuccessMessage: true, useToken: true }),
    "商品列表": new config({ url: '/goods/listGoods', showSuccessMessage: false, useToken: true }),
    "商品详情": new config({ url: '/goods/infoGoods', showSuccessMessage: false, useToken: true }),
    "商品字典列表": new config({ url: '/goods/listGoodsDic', showSuccessMessage: false, useToken: true }),
    "保存商品排序": new config({ url: '/goods/saveSort', showSuccessMessage: true, useToken: true }),
    "商品上移": new config({ url: '/goods/moveUp', showSuccessMessage: true, useToken: true }),
    "商品下移": new config({ url: '/goods/moveDown', showSuccessMessage: true, useToken: true }),
    "商品置顶": new config({ url: '/goods/moveTop', showSuccessMessage: true, useToken: true }),
    "商品取消置顶": new config({ url: '/goods/cancelTop', showSuccessMessage: true, useToken: true }),
}

export default ApiGoods